import {ApiClient} from '@hconnect/apiclient'
import {stringify} from 'qs'

import {RequestFunc, MonthlyHierarchyAnalysisDataPoint, MonthlyDataPointsPayload} from '../../types'

import {loggingDecorator} from './decorators'

const getMonthlyDataPointsImpl: RequestFunc<
  MonthlyDataPointsPayload,
  MonthlyHierarchyAnalysisDataPoint[]
> = async ({from, to, hierarchyIds, questionDifficulties, sectionIds}) => {
  const {data} = await ApiClient.axiosInstance.get<MonthlyHierarchyAnalysisDataPoint[]>(
    '/pom-questionnaires/analyses/monthly-data-points',
    {
      params: {
        from,
        to,
        hierarchyIds,
        questionDifficulties,
        sectionIds
      },
      paramsSerializer: (params) => stringify(params, {arrayFormat: 'repeat'})
    }
  )
  return data
}

export const getMonthlyDataPoints = loggingDecorator(getMonthlyDataPointsImpl)
